import React, { Fragment, useState, useEffect, useRef } from "react";

//************** Componentes PrimerReact **************/
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Calendar } from "primereact/calendar";

//************** Componentes generales **************/
import Card from "../../../../Base/Components/Card/Card";

import Loader from "../../../../Base/Components/Loader/Loader";

import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

//************** Servicios Creados **************/
import { fechaTemplate, decimalValueTemplate } from "../../../../Base/Services/TemplatesServices";
import { toastShow } from "../../../../Base/Services/ToastService";

import { getDateProduction } from "../../../../Base/Services/FechasService";

//************** Consultas API **************/

// import { getInvoicesCustomer, getInvoicesCustomerDates } from "../../../../API/Ventas/Facturas/FacturasRequest";
import { getInvoicesCustomer, getInvoicesCustomerDates } from "../../../API/Ventas/Facturas/FacturasRequest";
//************** Componentes Especificos **************/

// import ModalFacturas from "../../../Ventas/Facturas/ModalFacturas/ModalFacturas";
// import ModalFacturas from "../../Ventas/Facturas/ModalFacturas/ModalFacturas";

const ModalFacturasCliente = ({clienteFacturasDialog,setClienteFacturasDialog,hideDialogFacturasCliente,IdCustomer, CustomerName}) => {

    // const [clienteFacturasDialog, setClienteFacturasDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([])
    const [dates, setDates] = useState([new Date(), new Date()])

    const [facturaDialog, setFacturaDialog] = useState(false);
    const [IdFactura, setIdFactura] = useState(0)
    const [numeroFactura, setNumeroFactura] = useState('')

    const openModalFactura = (rowData) => {
        setFacturaDialog(true)
        setIdFactura(rowData.IdInvoiceIPS)
        setNumeroFactura(rowData.NumberInvoice)
    }
    const ohHideModalFactura = () => {
        setFacturaDialog(false)
        setLoading(false)
        setIdFactura(0)
        setNumeroFactura('')
        obtenerFacturasCliente()
    }


    const NumberInvoiceTemplate = (rowData) => {
        return <span onDoubleClick={() => openModalFactura(rowData)} style={{textAlign:'center'}}>{rowData.NumberInvoice}</span>
    }

    // const NumberInvoiceTemplate = (rowData) => {
    //     return <ModalFacturas IdFactura={rowData.IdInvoiceIPS} NumeroFactura={rowData.NumberInvoice} />
    //     // return <Button label={rowData.NumberInvoice} icon="" className="p-button-text" onDoubleClick={()=> openModalFacturas(rowData)} style={{ color: "black", fontSize: 12 }} />
    // }

    useEffect(() => {
       if(clienteFacturasDialog){
        setLoading(true)
        obtenerFacturasCliente()
       }else{
        setData([])
       }
    },[clienteFacturasDialog])


    const table = {
        Data: data,
        Columns: [
            // {
            //     field: 'IdInvoiceIPS',
            //     header: 'IdInvoiceIPS',
            //     className: 'Xsmall',
            //     frozen: 'true',
            //     alignFrozen: 'left'

            // },
            {
                field: 'NumberInvoice',
                header: 'NumberInvoice',
                className: 'large',
                body: (rowData) => rowData.IdInvoiceIPS ? NumberInvoiceTemplate(rowData) : null,
                Format: "Template",
                frozen: 'true',
                alignFrozen: 'left',
                Sumary: 'count'
            },
            {
                field: 'FechaFactura',
                header: 'FechaFactura',
                className: 'medium',
                Format: 'Template',
                body: (rowData) => fechaTemplate(rowData.FechaFactura)

            },
            {
                field: 'StatusName',
                header: 'Estado',
                className: 'medium',
                // Format: 'Template',
                // body: e => statusBodyTemplate(e)
            },
            {
                field: 'StyleCategory',
                header: 'Categoria',
                className: 'medium',
            },
            {
                field: 'CustomerName',
                header: 'Cliente',
                className: 'large',
                // Format: 'Template',
                // body: e => statusBodyTemplate(e)

            },
            {
                field: 'UnitName',
                header: 'Unidad',
                className: 'small',
                // Format: 'Template',
                // body: e => statusBodyTemplate(e)

            },
            {
                field: 'RollosT',
                header: 'Rollos',
                className: 'Xsmall',
                Sumary: 'sum',
                Format: "Decimal"
            }, {
                field: 'KgsT',
                header: 'Kgs',
                className: 'Xsmall',
                Format: "Decimal",
              
                Sumary: 'sum'
            },
            {
                field: 'YdsT',
                header: 'Yds',
                className: 'Xsmall',
                Format: "Decimal",
              
                Sumary: 'sum'
            }, {
                field: 'LbsT',
                header: 'Lbs',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'PcsT',
                header: 'Pcs',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'TotalISV',
                header: 'Total ISV',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'DescuentoRebajas',
                header: 'DescuentoRebajas',
                className: 'Xsmall',
                Format: "Decimal",
                Sumary: 'sum'
            },
            {
                field: 'Amount',
                header: 'Total $',
                className: 'small',
                Format: "Decimal",
                frozen: 'true',
                alignFrozen: 'right',
                Sumary: 'sum'
            },
            {
                field: 'ValorLps',
                header: 'Total L',
                className: 'small',
                Format: "Decimal",
                frozen: 'true',
                alignFrozen: 'right',
                Sumary: 'sum'
            },



            {
                field: 'Comment',
                header: 'Comment',
                className: 'Xlarge',
            },
        ]
    }

    const obtenerFacturasCliente = async () => {
        setLoading(true)
        const result = await getInvoicesCustomer(IdCustomer)
        if(result.length > 0){
            setData(result)
        }
        else{
            setData([])
        }
        setLoading(false)
    }


    // const openNew = () => {

    //     setClienteFacturasDialog(true)
    //     setLoading(false)
    //     obtenerFacturasCliente()
    // }

    // const hideDialog = () => {
    //     setClienteFacturasDialog(false)
    // }

    // const botones = () =>{
    //     if(nombre ===""){
    //         return   <Button className="p-button-rounded p-button-info p-button-text" 
    //         icon="ri-wallet-line" 
    //         onClick={openNew}/>
    //     }
    //     else{
    //        return <span style={{ color: "black", fontSize: 15 }}  onDoubleClick={openNew}>{nombre} </span>
    
    //     }
    // }

    const obtenerFacturasFechaCliente = async() =>{
        setLoading(true)
        setData([])
        if (!dates[0] !== null) {
            if (!dates[1]) {
                // toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
            }
            else {
                // const result = await getInvoicesDates(fechas)
                // console.log(result)

                const fechaFormato = getDateProduction(dates)
                // console.log(fechaFormato)
            
                const result = await getInvoicesCustomerDates(fechaFormato, IdCustomer)
                // console.log(result)
                if(result.length >0){

                    setData(result)
                }else{
                    setData([])
                }
              
                
            }

        } else {
            // toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
        }

        setLoading(false)
    }

    return (
      <Fragment>
        <Loader loading={loading} />
        {/* <Button className={className} icon={icono} onClick={openNew} label={nombre} style={nombre=== "" ? {fontSize: 16 }: { color: "black", fontSize: 12 }}/> */}
        {/* {botones()} */}
        <Dialog
          visible={clienteFacturasDialog}
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "80vw", height: "80vh" }}
          onHide={hideDialogFacturasCliente}
          header={
            <div className="d-flex">
              <h3 className="mx-3">
                Facturas: <strong>{CustomerName}</strong>
              </h3>
              <Calendar
                id="range"
                value={dates}
                onChange={(e) => setDates(e.value)}
                selectionMode="range"
                showIcon
                style={{ height: 35 }}
              />
              <Button
                className=" mx-2"
                icon="pi pi-search"
                loading={loading}
                onClick={() => obtenerFacturasFechaCliente()}
                style={{ height: 35 }}
              />
              <Button
                icon="ri-restart-line"
                loading={loading}
                onClick={() => obtenerFacturasFechaCliente()}
                style={{ height: 35 }}
              />
            </div>
          }
        >
          <Loader loading={loading} />

          <div className="pt-1" style={{ height: "65vh" }}>
            <AgGrid table={table} />
          </div>

          {/* <ModalFacturas
            facturaDialog={facturaDialog}
            setFacturaDialog={setFacturaDialog}
            ohHideModalFactura={ohHideModalFactura}
            IdFactura={IdFactura}
            NumeroFactura={numeroFactura}
          /> */}

          {/* {facturaDialog && (
            <ModalFacturas
              facturaDialog={facturaDialog}
              setFacturaDialog={setFacturaDialog}
              ohHideModalFactura={ohHideModalFactura}
              IdFactura={IdFactura}
              NumeroFactura={numeroFactura}
            />
          )} */}
        </Dialog>
      </Fragment>
    );
}

export default ModalFacturasCliente